import { combineReducers } from 'redux';
import { userReducer } from './user';
import type { UserState } from './user';

export interface RootState {
	user: UserState;
	router?: any;
}

export type { UserState };

// NOTE: current type definition of Reducer in 'redux-actions' module
// doesn't go well with redux@4
export const rootReducer = combineReducers<RootState>({
  user: userReducer as any
});
